export const state = () => (require('@pleinair/bigcolony-vue/store/locations/_state')())
export const mutations = require('@pleinair/bigcolony-vue/store/locations/_mutations')
export const actions = require('@pleinair/bigcolony-vue/store/locations/_actions')